import { useApiClient } from '../../hooks/useApiClient.ts';
import { Gender } from '../../types/Gender.type.ts';

export const useGenderApi = () => {
  const apiClient = useApiClient();

  return {
    getGenders: (excludeOther = false): Promise<Gender[]> =>
      apiClient(excludeOther ? `/genders/?exclude_other=true` : `/genders/`),
  };
};
